module.exports = __webpack_public_path__ + "img/copaAmerica212.5a9eb124.jpg";